<template>
    <div class="card mb-0" v-if="loadForm" v-loading="loading">
        <div class="card-header bg-info" style="height: 50px; display: flex; align-items: center">
            <div style="font-size: 16px; color: #fff">{{ title }}</div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-2">
                    <x-input v-model="form.number_full"
                             readonly
                             label="Número"
                             v-if="form.id"></x-input>
                    <x-select v-model="form.series"
                              label="Serie"
                              :options="series"
                              option-label="number"
                              option-value="number"
                              v-else
                              :disabled="!!form.id"></x-select>
                </div>
                <div class="col-md-2">
                    <x-select v-model="form.note_debit_type_id"
                              label="Tipo nota de débito"
                              :options="note_debit_types"
                              :disabled="!!form.id"
                              @input="changeNoteDebitType"></x-select>
                </div>
                <div class="col-lg-4 col-md-6">
                    <x-input label="Descripción"
                             v-model="form.note_description"></x-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{'has-danger': errors.customer_id}">
                        <label class="control-label">Cliente</label>
                        <el-select v-model="form.customer_id" filterable :disabled="true">
                            <el-option v-for="option in customers" :key="option.id" :value="option.id"
                                       :label="option.description"></el-option>
                        </el-select>
                        <small class="form-control-feedback" v-if="errors.customer_id"
                               v-text="errors.customer_id[0]"></small>
                    </div>
                </div>
                <div class="col-md-2">
                    <x-select v-model="form.currency_type_id"
                              label="Moneda"
                              :options="currency_types"
                              option-label="symbol"
                              option-value="id"
                              disabled></x-select>
                </div>
                <div class="col-md-2">
                    <div :class="{'has-danger': errors.date_of_issue}"
                         class="form-group">
                        <label class="control-label">Fecha de emisión</label>
                        <el-date-picker v-model="form.date_of_issue"
                                        :clearable="false"
                                        :picker-options="dateIssue"
                                        type="date"
                                        format="dd/MM/yyyy"
                                        value-format="yyyy-MM-dd"
                                        @change="changeDateOfIssue"></el-date-picker>
                        <small v-if="errors.date_of_issue"
                               class="form-control-feedback"
                               v-text="errors.date_of_issue[0]"></small>
                    </div>
                </div>
                <div class="col-md-2">
                    <x-input label="Orden Compra"
                             v-model="form.purchase_order"></x-input>
                </div>
                <div class="col-md-2">
                    <x-input label="Tipo de cambio"
                             readonly
                             v-model="form.exchange_rate_sale"></x-input>
                </div>
            </div>
            <div class="row" v-if="form.items && form.items.length > 0">
                <div class="col-12 table-responsive">
                    <table class="table table-sm"
                           v-if="form.note_debit_type_id !== '02'">
                        <thead>
                        <tr>
                            <th style="width: 30px">#</th>
                            <th class="font-weight-bold">Descripción</th>
                            <th class="text-center font-weight-bold">Unidad</th>
                            <th class="text-right font-weight-bold">Cantidad</th>
                            <th class="text-right font-weight-bold">Valor Unitario</th>
                            <th class="text-right font-weight-bold">Precio Unitario</th>
                            <th class="text-right font-weight-bold">Subtotal</th>
                            <th class="text-right font-weight-bold">Total</th>
                            <th style="width: 80px" v-if="showItemButtonAction"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, index) in form.items" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ row.name }}</td>
                            <td class="text-center">{{ row.unit_type_id }}</td>
                            <td class="text-right">{{ row.quantity }}</td>
                            <td class="text-right">{{ currency_type.symbol }} {{ row.unit_value }}</td>
                            <td class="text-right">{{ currency_type.symbol }} {{ row.unit_price }}</td>
                            <td class="text-right">{{ currency_type.symbol }} {{ row.total_value }}</td>
                            <td class="text-right">{{ currency_type.symbol }} {{ row.total }}</td>
                            <td class="text-right" v-if="showItemButtonAction">
                                <button class="btn waves-effect waves-light btn-xs btn-danger"
                                        type="button"
                                        @click.prevent="clickRemoveItem(index)"><i class="fas fa-trash"></i>
                                </button>
                                <button class="btn waves-effect waves-light btn-xs btn-info"
                                        type="button"
                                        @click="ediItem(row, index)">
                                    <span style='font-size:10px;'>&#9998;</span></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table table-sm" v-else>
                        <thead>
                        <tr>
                            <th style="width: 30px">#</th>
                            <th class="font-weight-bold">Descripción</th>
                            <th class="text-center font-weight-bold">Unidad</th>
                            <th class="text-right font-weight-bold" style="width: 180px;">Cantidad</th>
                            <th class="text-right font-weight-bold">Valor Unitario</th>
                            <th class="text-right font-weight-bold" style="width: 160px;">Precio Unitario</th>
                            <th class="text-right font-weight-bold">Subtotal</th>
                            <th class="text-right font-weight-bold">Total</th>
                            <th class="text-right"
                                v-if="form.note_debit_type_id === '02' && form.items.length > 1"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, index) in form.items" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ row.name }}</td>
                            <td class="text-center">{{ row.unit_type_id }}</td>
                            <td class="text-right">
                                <x-input-number v-model="row.quantity"
                                                center
                                                :controls="true"
                                                :max="row.quantity_init"
                                                @input="changeQuantity(row, index)"
                                                v-if="form.note_debit_type_id === '07'"></x-input-number>
                                <span v-else>{{ row.quantity }}</span>
                            </td>
                            <td class="text-right">{{ currency_type.symbol }} {{ row.unit_value }}</td>
                            <td class="text-right">
                                <x-input-number v-model="row.unit_price"
                                                center
                                                :controls="false"
                                                @input="changeUnitPrice(row, index)"
                                                v-if="form.note_debit_type_id === '02'"></x-input-number>
                                <span v-else>{{ row.unit_price }}</span>
                            </td>
                            <td class="text-right">{{ currency_type.symbol }} {{ row.total_value }}</td>
                            <td class="text-right">{{ currency_type.symbol }} {{ row.total }}</td>
                            <td class="text-right" v-if="form.note_debit_type_id === '02'  && form.items.length > 1">
                                <button class="btn waves-effect waves-light btn-xs btn-danger"
                                        type="button"
                                        @click.prevent="clickRemoveItem(index)"><i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-12 col-lg-4">
                </div>
                <div class="col-12 col-md-8 table-responsive">
                    <table class="table table-sm text-right" v-if="form && form.items.length > 0">
                        <tbody>
                        <tr v-if="form.total_exportation > 0">
                            <td>OP.EXPORTACIÓN</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.total_exportation }}</td>
                        </tr>
                        <tr v-if="form.total_free > 0">
                            <td>OP.GRATUITAS</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.total_free }}</td>
                        </tr>
                        <tr v-if="form.total_unaffected > 0">
                            <td>OP.INAFECTAS</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.total_unaffected }}</td>
                        </tr>
                        <tr v-if="form.total_exonerated > 0">
                            <td>OP.EXONERADAS</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.total_exonerated }}</td>
                        </tr>
                        <tr v-if="form.total_taxed > 0">
                            <td>OP.GRAVADA</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.total_taxed }}</td>
                        </tr>
                        <tr v-if="form.total_prepayment > 0">
                            <td>ANTICIPOS</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.total_discount }}</td>
                        </tr>
                        <tr>
                            <td>SUBTOTAL</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.subtotal }}</td>
                        </tr>
                        <tr>
                            <td>IGV</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td style="width: 100px">{{ form.total_igv }}</td>
                        </tr>
                        <tr v-if="form.total_isc > 0">
                            <td>ISC</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.total_isc }}</td>
                        </tr>
                        <tr v-if="form.total_plastic_bag_taxes > 0">
                            <td>ICBPER</td>
                            <td>:</td>
                            <td>{{ currency_type.symbol }}</td>
                            <td>{{ form.total_plastic_bag_taxes }}</td>
                        </tr>
                        <tr>
                            <td style="font-weight: bolder; font-size: 18px; padding: 16px 0;">IMPORTE TOTAL</td>
                            <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 40px">:</td>
                            <td style="font-weight: bolder; font-size: 18px; padding: 16px 0;">{{ currency_type.symbol }}</td>
                            <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 100px">{{ form.total }}</td>
                        </tr>
                        <tr>
                            <td style="font-weight: bolder; font-size: 18px; padding: 16px 0;">IMPORTE REFERENCIAL</td>
                            <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 40px">:</td>
                            <td style="font-weight: bolder; font-size: 18px; padding: 16px 0;">{{ currency_type.symbol }}</td>
                            <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 100px">{{ referenceTotal }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-right">
                    <button class="btn btn-default"
                            style="min-width: 180px"
                            @click.prevent="clickClose">Cancelar
                    </button>
                    <x-button-submit text="Generar"
                                     :loading="loading_submit"
                                     :disabled="loading_submit"
                                     @click="onSubmit"
                                     v-if="form.items.length > 0"></x-button-submit>
                </div>
            </div>
        </div>

        <store-finish :showDialog.sync="showDialogOptions"
                      :isContingency="is_contingency"
                      :record-data="recordData"
                      :resource="resource"
                      :parent-table="parentTable"
                      :show-new="false"
                      :configuration="configuration"></store-finish>
    </div>
</template>

<script>

import {functions, exchangeRate} from '../../../mixins/functions'
import {calculateRowItem, fCalculateDiscountGlobal, fCalculateTotal} from '../../../helpers/functions_3'
import XSelect from "../../../components/Form/XSelect.vue"
import XInput from "../../../components/Form/XInput.vue"
import XButtonSubmit from "../../../components/Form/XButtonSubmit.vue"
import XInputNumber from "../../../components/Form/XInputNumber.vue"
import XDatePicker from "../../../components/Form/XDatePicker.vue"
import XButtonPrimary from "../../../components/Form/XButtonPrimary.vue"
import XButtonIcon from "../../../components/Form/XButtonIcon.vue"
import StoreFinish from "./partials/Finish.vue"
import moment from "moment";

export default {
    components: {
        XButtonIcon,
        XButtonPrimary,
        XDatePicker,
        XInputNumber,
        XButtonSubmit,
        XInput,
        XSelect,
        StoreFinish},
    mixins: [
        functions,
        exchangeRate],
    props: [
        'document_affected',
        'configuration',
        'parentTable',
        'parentId',
        'documentAffectedId',
        'action',
    ],
    data() {
        return {
            loadForm: false,
            recordItem: null,
            isEditItemNote: false,
            showDialogAddItem: false,
            showDialogOptions: false,
            loading_submit: false,
            loading: false,
            title: 'Nota de débito',
            resource: 'documents',
            errors: {},
            form: {},
            document_types: [],
            currency_types: [],
            customers: [],
            all_series: [],
            series: [],
            currency_type: {},
            documentNewId: null,
            all_note_debit_types: [],
            note_debit_types: [],
            affectationIgvTypes: [],
            user: {},
            document: {},
            operation_types: [],
            is_contingency: false,
            affected_documents: [],
            temp_total: 0,
            apply_change_has_discounts: false,
            recordData: null,
            sellers: [],
            establishmentId: null,
            sellerId: null,
            referenceItems: [],
            referenceTotal: 0,
            itemFree: null,
            isExportation: false,
            isCalculateFee: false,
            accumulatedFee: 0,
            dateIssue: {
                disabledDate(time) {
                    return time.getTime() > moment();
                }
            },
        }
    },
    async created() {
        console.log('created')
        this.loadForm = false
        this.initForm()
        await this.$http.get(`/store/get_tables`)
            .then(response => {
                let data = response.data;
                this.currency_types = data.currency_types;
                this.all_series = data.series;
                this.all_note_debit_types = data.note_debit_types;
                this.operation_types = data.operation_types;
                this.affectationIgvTypes = data.affectation_igv_types;
                this.user = data.user;
                this.sellers = data.sellers;
                this.sellerId = data.seller_id;
                this.establishmentId = data.establishment_id;
                this.itemFree = data.item_free;
            })

        await this.initFormData();
        await this.getPercentageIgv();

        let url = `/store/record/documents/${this.documentAffectedId}/note_debits`;
        if (this.action === 'edit') {
            url = `/store/record/note_debits/${this.parentId}/note_debits/${this.action}`;
        }
        await this.$http.get(url)
            .then(response => {
                let data = response.data
                this.form = Object.assign({}, this.form, data.form)
                let its = []
                data.items.forEach((row) => {
                    row.unit_price_init = row.unit_price
                    its.push(calculateRowItem(row, this.percentageIgv, this.form.use_unit_price))
                })
                this.referenceItems = its
                this.form.items = its
                this.isExportation = this.form.operation_type_id.startsWith('02')
                this.customers = data.persons
                this.referenceTotal = this.form.reference_total
            })
            .finally(() => this.loading_submit = false)
        this.currency_type = this.currency_types.find(row => row.id === this.form.currency_type_id)
        this.filterNoteDebitTypes()
        this.filterSeries()
        this.changeNoteDebitType()
        this.loadForm = true
    },
    computed: {
        showItemButtonAction() {
            return !(['02'].includes(this.form.note_debit_type_id))
        },
    },
    methods: {
        initForm() {
            this.errors = {}
            this.form = {
                establishment_id: null,
                document_type_id: '08',
                series: null,
                number: '#',
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                customer_id: null,
                currency_type_id: null,
                purchase_order: null,
                exchange_rate_sale: 0,
                note_debit_type_id: null,
                note_credit_or_debit_type_id: null,
                note_description: null,
            }
        },
        initFormData() {
            this.form.establishment_id = this.establishmentId;
            this.form.seller_id = this.sellerId;
        },
        calculateTotal() {
            console.log('calculateTotal');
            this.form = Object.assign({}, this.form, fCalculateTotal(this.form, this.percentageIgv, this.form.use_unit_price))
            this.calculateDiscountGlobal();
        },
        calculateDiscountGlobal() {
            console.log('calculateDiscountGlobal');
            this.form = Object.assign({}, this.form,
                fCalculateDiscountGlobal(this.form, this.enabled_discount_global, this.discount_global_type, this.discount_global_amount))
            this.getTotal();
        },
        getTotal() {
            console.log('getTotal');
            let total = parseFloat(this.form.total);
            let total_retention = 0;
            let total_detraction = 0;
            this.form.total_payment = _.round(total - total_retention - total_detraction, 2).toFixed(2);
        },
        clickRemoveFee(index) {
            this.form.fee.splice(index, 1);
            this.calculateFee();
        },
        clickAddFee() {
            let date = null;
            if (this.form.fee.length === 0) {
                date = moment().add(1, 'days').format('YYYY-MM-DD')
            } else {
                date = moment().add(this.form.fee.length, 'months').format('YYYY-MM-DD')
            }
            this.form.fee.push({
                date: date,
                currency_type_id: this.form.currency_type_id,
                amount: 0,
            })
            this.calculateFee();
        },
        calculateFee() {
            this.isCalculateFee = true;
            let fee_count = this.form.fee.length;
            let total = this.referenceTotal;
            let total_amount = 0;
            let amount = parseFloat((total / fee_count).toFixed(2));
            this.form.fee.forEach((row, index) => {
                if (index === fee_count - 1) {
                    amount = parseFloat((total - total_amount).toFixed(2))
                }
                row.amount = amount
                total_amount += parseFloat(amount)
            })
            this.calculateAccumulatedFee();
            this.$nextTick(() => {
                this.isCalculateFee = false // Asegura que el flag se desactive después del re-render
            })
        },
        calculateAccumulatedFee() {
            console.log('calculateAccumulatedFee')
            let total_amount = 0
            this.form.fee.forEach((row, index) => {
                total_amount += parseFloat(row.amount)
            })
            this.accumulatedFee = parseFloat(total_amount.toFixed(2))
        },
        changeAmountFee() {
            if (!this.isCalculateFee) {
                console.log('changeAmountFee')
                this.calculateAccumulatedFee()
            }
        },
        filterNoteDebitTypes() {
            console.log('filterNoteDebitTypes')
            this.note_debit_types = this.all_note_debit_types
        },
        changeNoteDebitType() {
            if (this.form.note_debit_type_id === '02') {
                this.form.fee = [];
                this.form.items = [];
                this.referenceItems.forEach(row => {
                    this.form.items.push(this.addItemToForm(row.name, row.description, row.quantity, row.affectation_igv_type_id, row.unit_type_id))
                    // this.addItemToForm(row.name, row.quantity, row.affectation_igv_type_id, row.unit_type_id)
                })
                this.calculateTotal()
            }
        },
        addItemToForm(name, description, quantity, affectation_igv_type_id, unit_type_id,
                      unit_value_init = 0, unit_value = 0, unit_price_init = 0, unit_price = 0) {
            let affectationIgvType = this.affectationIgvTypes.find(row => row.id === affectation_igv_type_id);
            return {
                item_id: this.itemFree.id,
                name: name,
                description: description,
                affectation_igv_type_id_init: affectation_igv_type_id,
                affectation_igv_type_id: affectation_igv_type_id,
                affectation_igv_type_name: affectationIgvType.name,
                affectation_igv_type: affectationIgvType,
                currency_type_id: this.form.currency_type_id,
                currency_type_id_init: this.form.currency_type_id,
                price_type_id: '01',
                has_igv: true,
                unit_type_id: unit_type_id,
                quantity: quantity,
                unit_value_init: unit_value_init,
                unit_value: unit_value,
                unit_price_init: unit_price_init,
                unit_price: unit_price,
                percentage_igv: Number(this.percentageIgv) * 100,
                total_discount: 0,
                total_charge: 0,
                total_isc: 0,
                total_base_isc: 0,
                total_plastic_bag_taxes: 0,
                total_base_igv: 0,
                total_igv: 0,
                total_taxes: 0,
                total_value: 0,
                total: 0,
                fee: [],
                discounts: [],
            }
        },
        ediItem(row, index) {
            row.indexi = index
            this.recordItem = row
            this.isEditItemNote = true
            this.showDialogAddItem = true
        },
        filterSeries() {
            this.form.series = null
            let firstChar = (this.form.group_id === '01') ? 'F' : 'B'
            this.series = this.all_series.filter(s => {
                return (s.document_type_id === this.form.document_type_id && s.number.charAt(0) === firstChar)
            })
            this.form.series = (this.series.length > 0) ? this.series[0].number : null
        },
        async changeDateOfIssue() {
            await this.searchExchangeRateByDate(this.form.date_of_issue).then(response => {
                this.form.exchange_rate_sale = response
            })
            await this.getPercentageIgv();
        },
        clickRemoveItem(index) {
            this.form.items.splice(index, 1)
            this.calculateTotal()
        },
        async onSubmit() {
            if (this.form.note_description === '' || this.form.note_description === null) {
                return this.$message.error(`La descripción de la nota de crédito es requerida`)
            }

            let errorItem = false
            let errorLine = 0
            this.form.items.forEach(row => {
                if (parseFloat(row.total) === 0) {
                    errorItem = true
                }
                errorLine++
            })

            if (errorItem) {
                return this.$message.error(`Error en línea #${errorLine} el total no puede ser cero`)
            }

            if (parseFloat(this.form.total) <= 0) {
                return this.$message.error(`El importe total debe ser mayor a cero`)
            }

            if (['02'].includes(this.form.note_debit_type_id) && parseFloat(this.referenceTotal) <= parseFloat(this.form.total)) {
                return this.$message.error(`El importe total debe ser menor que el importe referencial`)
            }

            this.form.note_credit_or_debit_type_id = this.form.note_debit_type_id

            let path = `/${this.resource}`;
            if (this.form.id) {
                path = `/${this.resource}/${this.form.id}/update`;
            }

            this.loading_submit = true
            await this.$http.post(path, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.recordData = response.data.data
                        this.documentNewId = response.data.data.id
                        this.showDialogOptions = true
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                })
                .finally(() => {
                    this.loading_submit = false
                })
        },
        changeUnitPrice(row, index) {
            console.log('changeUnitPrice')
            row.unit_price_init = row.unit_price
            if (['10', '11', '12', '13', '14', '15', '16'].indexOf(row.affectation_igv_type_id_init) > -1) {
                if (row.has_igv) {
                    row.unit_value_init = Number((row.unit_price_init / (1 + this.percentageIgv)).toFixed(6))
                    row.unit_value = row.unit_value_init
                } else {
                    row.unit_price_init = Number((row.unit_value_init * (1 + this.percentageIgv)).toFixed(6))
                }
            } else {
                if (row.has_igv) {
                    row.unit_value_init = Number(row.unit_price_init)
                    row.unit_value = row.unit_value_init
                } else {
                    row.unit_price_init = Number(row.unit_value_init)
                }
            }
            this.form.items[index] = calculateRowItem(_.cloneDeep(row), this.percentageIgv, this.form.use_unit_price)
            this.calculateTotal()
        },
        changeQuantity(row, index) {
            console.log('changeQuantity');
            this.form.items[index] = calculateRowItem(_.cloneDeep(row), this.percentageIgv, this.form.use_unit_price)
            this.calculateTotal()
        },
        clickClose() {
            location.href = '/documents'
        }
    }
}
</script>
